var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mh-middle"},[_c('div',{staticClass:"mh-middle-inner"},[_c('ContentTitle',{attrs:{"title":"Documents"}}),_c('div',{staticClass:"mh-middle-container"},[_c('div',{staticClass:"mh-time-entries-top mh-time-off"},[_c('Documents',{attrs:{"path":"branch/","hideActions":true,"hideContextMenu":true}})],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }